import { MediaMgmtService } from '../services/mediamgmt-service';
import { TrainingDayLogv2 } from './traininghistorymodel';

export interface IWorkoutLogContext {
    currentLog?: TrainingDayLogv2;
    previousLog?: TrainingDayLogv2;
}

export class ClientWorkoutLogContext extends EventTarget {
    private _currentLog?: TrainingDayLogv2 = undefined;
    private _previousLog?: TrainingDayLogv2 = undefined;

    constructor(data: Partial<IWorkoutLogContext>) {
      super();
      this._currentLog = data.currentLog ?? undefined;
      this._previousLog = data.previousLog ?? undefined;
    }

    get currentLog() {
      return this._currentLog;
    }

    set currentLog(value: TrainingDayLogv2|undefined) {
      this._currentLog = value;
      this.dispatchEvent(new Event('logChanged'));
    }

    get previousLog() {
      return this._previousLog;
    }

    set previousLog(value: TrainingDayLogv2|undefined) {
      this._previousLog = value;
      this.dispatchEvent(new Event('logChanged'));
    }
}

export class MediaURLCache {
  #userUUID: string = '';
  #images = new Map<string, { expiry: number, url: string }>();
  #videos = new Map<string, { expiry: number, token: string }>();

  constructor() {
  }

  setUserUUID(userUUID: string) {
    this.#userUUID = userUUID;
  }

  async getImageURL(mediaUUID: string) {
    if (this.#images.has(mediaUUID)) {
      const elm = this.#images.get(mediaUUID);
      const { expiry, url } = elm!;

      if (Date.now() < expiry) {
        return url;
      }
    }
    const url = await MediaMgmtService.getImageDownloadUrl(this.#userUUID, mediaUUID, 'public');
    if (url) {
      this.#images.set(mediaUUID, { expiry: Date.now() + 12*60*60*1000, url });
    }
    return url;
  }

  async getVideoThumbnailURL(mediaUUID: string) {
    if (this.#videos.has(mediaUUID)) {
      const elm = this.#videos.get(mediaUUID);
      const { expiry, token } = elm!;

      if (Date.now() < expiry) {
        return `https://customer-maloftn8msumvi6g.cloudflarestream.com/${token}/thumbnails/thumbnail.jpg`;
      }
    }
    const token = await MediaMgmtService.getVideoDownloadToken(this.#userUUID, mediaUUID);
    if (token) {
      this.#videos.set(mediaUUID, { expiry: Date.now() + 12*60*60*1000, token });
    }
    return `https://customer-maloftn8msumvi6g.cloudflarestream.com/${token}/thumbnails/thumbnail.jpg`;
  }

  async getVideoIFrameURL(mediaUUID: string) {
    if (this.#videos.has(mediaUUID)) {
      const elm = this.#videos.get(mediaUUID);
      const { expiry, token } = elm!;

      if (Date.now() < expiry) {
        return `https://customer-maloftn8msumvi6g.cloudflarestream.com/${token}/iframe`;
      }
    }
    const token = await MediaMgmtService.getVideoDownloadToken(this.#userUUID, mediaUUID);
    if (token) {
      this.#videos.set(mediaUUID, { expiry: Date.now() + 12*60*60*1000, token });
    }
    return `https://customer-maloftn8msumvi6g.cloudflarestream.com/${token}/iframe`;
  }

}


export const clientWorkoutLogContext = new ClientWorkoutLogContext({});
export const mediaURLCache = new MediaURLCache();